export const ClientMixin = {
  methods:{
    checkingValueChange (oldValue, newValue) {
      return oldValue === newValue
    },
    onCellValueChanged (params) {
      console.log(params)
      const data = []
      data.is_dynamic = params.colDef.field_type === 'dynamic'
      //data.colId = params.column.getId()
      data.colId = params.colDef.field
      data.user_id = params.data.basic_details.client_users_id
      const hasCheckingValueChange = this.checkingValueChange(params.oldValue, params.newValue)

      //
      //

      //
      if (!hasCheckingValueChange) {
        if (data.colId === 'basic_details.first_name') {
          data.fieldvalue = params.data.basic_details.first_name
          data.colId = 'first_name'
          if (data.fieldvalue === '') {
            this.$vs.notify({
              title: 'Warning',
              text: 'Name field can not be empty',
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'warning',
              time: 8000
            })
            return false
          }
        } else if (data.colId === 'basic_details.middle_name') {
          data.fieldvalue = params.data.basic_details.middle_name
          data.colId = 'middle_name'

          if (data.fieldvalue === '') {
            console.log(data.colId)
            this.$vs.notify({
              title: 'Warning',
              text: 'Name field can not be empty',
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'warning',
              time: 8000
            })
            return false
          }
        } else if (data.colId === 'basic_details.last_name') {
          data.fieldvalue = params.data.basic_details.last_name
          data.colId = 'last_name'
          if (data.fieldvalue === '') {
            this.$vs.notify({
              title: 'Warning',
              text: 'Name field can not be empty',
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'warning',
              time: 8000
            })
            return false
          }
        } else if (data.colId === 'basic_details.email') {
          data.fieldvalue = params.data.basic_details.email
          const hasCheckingEmail = this.ValidateEmail(params.data.basic_details.email)
          data.colId = 'email'
          if (!hasCheckingEmail) {

            this.revertOldValue(params.rowIndex, data.colId, params.oldValue)
            this.showSuccessMessage('Error', 'Email Not Validated', 'warning')
            return false
          }
          // if (data.fieldvalue === '') {
          //   this.$vs.notify({
          //     title: 'Warning',
          //     text: 'Email field must be greater than 0',
          //     iconPack: 'feather',
          //     icon: 'icon-alert-circle',
          //     color: 'warning',
          //     time: 8000
          //   })
          //   return false
          // }
        } else if (data.colId === 'basic_details.mobile') {
          const phoneno = /^\d+$/
          data.fieldvalue = params.data.basic_details.mobile
          data.colId = 'mobile'
          if (data.fieldvalue.match(phoneno)) {
            data.fieldvalue = params.data.basic_details.mobile
          } else {
            this.$vs.notify({
              title: 'Warning',
              text: 'Phone field must be numeric',
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'warning',
              time: 8000
            })
            return false
          }
        } else if (data.colId === 'basic_details.address.address1') {
          data.fieldvalue = params.data.basic_details.address.address1
          data.colId = 'address1'
          if (data.fieldvalue === '') {
            this.showSuccessMessage('Warning', 'No changes has been made', 'warning')
            return false
          }
        } else if (data.colId === 'basic_details.address.address2') {
          data.fieldvalue = params.data.basic_details.address.address2
          data.colId = 'address2'
          if (data.fieldvalue === '') {
            this.showSuccessMessage('Warning', 'No changes has been made', 'warning')
            return false
          }
        } else if (data.colId === 'basic_details.address.state') {
          data.fieldvalue = params.data.basic_details.address.state
          data.colId = 'state'
          if (data.fieldvalue === '') {
            this.showSuccessMessage('Warning', 'No changes has been made', 'warning')
            return false
          }
        } else if (data.colId === 'basic_details.address.city') {
          data.fieldvalue = params.data.basic_details.address.city
          data.colId = 'city'
          if (data.fieldvalue === '') {
            this.showSuccessMessage('Warning', 'No changes has been made', 'warning')
            return false
          }
        } else if (data.colId === 'basic_details.address.zip') {
          data.fieldvalue = params.data.basic_details.address.zip
          data.colId = 'zip'
          if (data.fieldvalue === '') {
            this.showSuccessMessage('Warning', 'No changes has been made', 'warning')
            return false
          }
        } else {
          console.log(params)
          if (params.colDef.input_type === 'number') {
            const numdynamic = /^\d+$/
            data.fieldvalue = params.data[data.colId]

            if (data.fieldvalue.match(numdynamic)) {
              data.fieldvalue = params.data[data.colId]
            } else {
              this.showSuccessMessage('Error', 'This field Cant be string', 'warning')
              this.revertOldValue(params.rowIndex, data.colId, params.oldValue)
              return false
            }
          } else {
            data.fieldvalue = params.data[data.colId]
            if (data.fieldvalue === '') {
              this.showSuccessMessage('Warning', 'No changes has been made', 'warning')
              return false
            }
          }
        }
        console.log(data, params.data.basic_details.address)
        this.Update_client(data, params.data.basic_details.address)
      } else {
        this.showSuccessMessage('Changes', 'No Changes Has been made', 'warning')
      }

      //

    },
    /*  async Update_client (data, fulladdress) {
      console.log(data)
      const user_id = data.user_id
      const payload = {
        updateField: fulladdress
      }
      if (
        data.colId === 'address1' ||
          data.colId === 'address2' ||
          data.colId === 'state' ||
          data.colId === 'city' ||
          data.colId === 'zip'
      ) {
        const keyName = data.colId
        fulladdress[keyName] = data.fieldvalue
        payload.updateField = {
          address: fulladdress
        }
      } else {
        console.log(data)
        payload.updateField = {
          [data.colId]: data.fieldvalue
        }
      }
      try {
        const customer_id= this.$store.getters.customerId
        console.log(customer_id)
        const { data } = await updateClient(user_id, payload,customer_id)
        this.$vs.notify({
          title: 'Success',
          text: data.message,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'success'
        })
      } catch (api_error) {

        this.$vs.notify({
          title: 'Warning',
          text: api_error.message,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'warning',
          time: 3000
        })
      }
    }, */
    revertOldValue (index, field, value) {

      this.tableData[index][field] = value

      this.gridOptions.api.refreshCells()
    }
  },
  data () {
    return {
      columnDefs:[],
      staticFieldTable: [
        {
          headerName: '',
          minWidth: 50,
          field: 'isSelected',
          filter: true,
          checkboxSelection: true,
          editable: (params) => {
            if (!this.checkEditPermission()) {
              return false
            }
            if (params.data.basic_details.active_user === '1') {
              return true
            } else {
              return false
            }
          },
          headerCheckboxSelectionFilteredOnly: true,
          headerCheckboxSelection: true
        },
        {
          headerName: '#',
          field: 'row_index',
          sortable: false,
          filter: true,
          minWidth: 60,
          resizable: true,
          editable: false
        },
        {
          headerName: 'First Name',
          field: 'basic_details.first_name',
          minWidth: 150,
          filter: true,
          cellStyle: { color: 'blue' }
        },
        {
          headerName: 'Middle Name',
          field: 'basic_details.middle_name',
          filter: true,
          minWidth: 150,
          editable: (params) => {
            if (!this.checkEditPermission()) {
              return false
            }
            if (params.data.basic_details.active_user === '1') {
              return true
            } else {
              return false
            }
          }
        },
        {
          headerName: 'Last Name',
          field: 'basic_details.last_name',
          filter: true,
          minWidth: 150,
          editable: (params) => {
            if (!this.checkEditPermission()) {
              return false
            }
            if (params.data.basic_details.active_user === '1') {
              return true
            } else {
              return false
            }
          }
        },
        {
          headerName: 'Email',
          field: 'basic_details.email',
          filter: true,
          minWidth: 150,
          editable: (params) => {
            if (!this.checkEditPermission()) {
              return false
            }
            if (params.data.basic_details.active_user === '1') {
              return true
            } else {
              return false
            }
          }
        },
        {
          headerName: 'Phone',
          field: 'basic_details.mobile',
          filter: true,
          minWidth: 150,
          editable: (params) => {
            if (!this.checkEditPermission()) {
              return false
            }
            if (params.data.basic_details.active_user === '1') {
              return true
            } else {
              return false
            }
          }
        },
        {
          headerName: 'User Type',
          // field: 'basic_details.user_type',
          valueGetter: (params) => {
            if (!this.checkEditPermission()) {
              return false
            }
            if (params.data.basic_details.user_type === 'Children') {
              return 'Child'
            } else {
              return params.data.basic_details.user_type
            }
          },
          filter: true,
          minWidth: 150,
          editable: false
          // editable: (params) => {
          //   if (params.data.basic_details.active_user === '1') {
          //     return true
          //   } else {
          //     return false
          //   }
          // }
        },
        {
          headerName: 'Root User',
          // field: 'basic_details.root_user',
          // valueFormatter:(params) => { return params.user_type.toUpperCase() },
          valueGetter: (params) => {
            if (params.data.basic_details.root_user === 'SELF') {
              return 'Self'
            } else {
              return params.data.basic_details.root_user
            }
          },
          filter: true,
          minWidth: 150,
          editable: false
        },
        {
          headerName: 'Address1',
          field: 'basic_details.address.address1',
          filter: true,
          minWidth: 150,
          editable: (params) => {
            if (!this.checkEditPermission()) {
              return false
            }
            if (params.data.basic_details.active_user === '1') {
              return true
            } else {
              return false
            }
          }
        },
        {
          headerName: 'Address2',
          field: 'basic_details.address.address2',
          filter: true,
          minWidth: 150,
          editable: (params) => {
            if (!this.checkEditPermission()) {
              return false
            }
            if (params.data.basic_details.active_user === '1') {
              return true
            } else {
              return false
            }
          }
        },
        // {
        //   headerName: 'City',
        //   field: 'basic_details.address.city',
        //   filter: true,
        //   minWidth: 150,
        //   editable: (params) => {
        //     if (params.data.basic_details.active_user === '1') {
        //       return true
        //     } else {
        //       return false
        //     }
        //   }
        // },
        {
          headerName: 'County/State',
          field: 'basic_details.address.state',
          filter: true,
          minWidth: 150,
          editable: (params) => {
            if (!this.checkEditPermission()) {
              return false
            }
            if (params.data.basic_details.active_user === '1') {
              return true
            } else {
              return false
            }
          }
        },
        {
          headerName: 'Postcode/Zip',
          field: 'basic_details.address.zip',
          filter: true,
          minWidth: 150,
          editable: (params) => {
            if (!this.checkEditPermission()) {
              return false
            }
            if (params.data.basic_details.active_user === '1') {
              return true
            } else {
              return false
            }
          }
        },
        {
          headerName: 'Country',
          field: 'basic_details.address.country.country_name',
          filter: true,
          minWidth: 150,
          editable: false
          // editable: (params) => {
          //   if (params.data.basic_details.active_user === '1') {
          //     return true
          //   } else {
          //     return false
          //   }
          // }
        },
        {
          headerName: 'City',
          field: 'basic_details.address.city',
          filter: true,
          minWidth: 125,
          editable: (params) => {
            if (!this.checkEditPermission()) {
              return false
            }
            if (params.data.basic_details.active_user === '1') {
              return true
            } else {
              return false
            }
          }
        },
        {
          headerName: 'Tags',
          field: 'tags',
          filter: true,
          minWidth: 125,
          editable: false,
          cellRendererFramework: 'TagShow'
        }
        /*  {
          headerName: 'Active',
          field: 'actionData',
          width: 100,
          editable: false,
          filter: false,
          cellRendererFramework: 'ToggleActions'
        } */
        // {
        //   headerName: 'Edit',
        //   field: 'actionData',
        //   width: 80,
        //   editable: false,
        //   filter: false,
        //   cellRendererFramework: 'EditActions'
        // },
        // {
        //   headerName: 'Delete',
        //   field: 'actionData',
        //   width: 100,
        //   editable: false,
        //   filter: false,
        //   cellRendererFramework: 'DeleteActions'
        // },
        // {
        //   headerName: 'Preview',
        //   field: 'actionData',
        //   width: 110,
        //   editable: false,
        //   filter: false,
        //   cellRendererFramework: 'PreviewActions'
        // }
        // {
        //   headerName: 'Action',
        //   field: 'actionData',
        //   width: 100,
        //   editable: false,
        //   filter: false,
        //   cellRendererFramework: 'CellRendererActions'
        // }
      ]
    }
  }
}
